import {Injectable} from '@angular/core';
import {StorageService} from '../storage/storage.service';
import {ImageAsset} from '../../model/typings/asset.types';

@Injectable()
export class AssetStateService {
  imageAssetsForView: ImageAsset[];

  constructor(private storageService: StorageService) {
    this.resetAssetStateService();
  }

  // TODO: This needs to update a map of views based on project cache history length. Maybe stored in sessionStorage?
  updateImageAssetsForView(imageAssetsForView: ImageAsset[]) {
    console.log(`CPUI - AssetStateService.updateImageAssetsForView()`, imageAssetsForView);
    this.imageAssetsForView = imageAssetsForView;
    return this.imageAssetsForView;
  }

  resetImageAssetsForView() {
    console.log(`CPUI - AssetStateService.resetImageAssetsForView()`);
    this.imageAssetsForView = null;
  }

  private resetAssetStateService() {
    console.log(`CPUI - AssetStateService.resetAssetStateService()`);
    this.resetImageAssetsForView();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/asset/asset-state.service.ts